







































// @ts-ignore
import v8n from 'v8n';
import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator';
import { Lot, LotRegion, ApiError } from '@/api';
import { snackModule } from '@/store';
import ConfirmDialog from '@/components/admin/ConfirmDialog.vue';

@Component({
  components: { ConfirmDialog },
})
export default class extends Vue {
  @Prop({ required: true }) readonly lotId: number;
  @Prop({ required: false }) readonly selectedRegion: LotRegion;

  loading: boolean = false;
  valid: boolean = false;
  complete: boolean = false;
  error: string = '';

  lot: Lot | null = null;

  region: LotRegion | null = null;

  closeConfirmDialog: boolean = false;

  requiredString = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'This field is required',
  ];
  requiredNumber = [
    (v: string) =>
      v8n()
        .number()
        .greaterThan(0)
        .test(Number(v)) || 'Must be a number greater than 0',
  ];

  get regionId() {
    return this.selectedRegion.id;
  }

  get modalTitle() {
    return this.selectedRegion ? 'Edit Region' : 'Add Region';
  }

  confirmClose() {
    if (this.region && this.region.isDirty()) {
      this.closeConfirmDialog = true;
    } else {
      this.close();
    }
  }

  close() {
    this.$emit('close-region');
  }

  async save() {
    if (!this.region || !this.lot) {
      return;
    }

    this.region.lot = this.lot;

    try {
      await this.region.save({ with: ['lot.id'] });

      this.$emit('save-region');
    } catch (err) {
      err.response.errors.forEach((e: ApiError) =>
        snackModule.showSnackbar(e.detail),
      );
    }
  }

  async mounted() {
    try {
      this.lot = (await Lot.find(this.lotId)).data;
    } catch (err) {
      snackModule.showSnackbar('Lot not found');
    }

    if (this.selectedRegion && this.selectedRegion.id) {
      try {
        const scope = await LotRegion.find(this.selectedRegion.id);
        this.region = scope.data;
      } catch (err) {
        // most likely this means not found
        snackModule.showSnackbar('Region not found');
      }
    } else {
      this.region = new LotRegion();
    }
  }
}
